import { AdjustedApplicantFeeActivity } from "../types";
import { formatToCurrency } from "shared/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown02Icon } from "@hugeicons-pro/core-stroke-rounded";

export const AdjustedApplicantFeeOverrides = ({
  activityItem
}: {
  activityItem: AdjustedApplicantFeeActivity;
}) => {
  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000 space-x-2">
        <span>Pet rent adjusted</span>
        <span className="font-normal">
          for {activityItem.details.applicant_name || "--"}
        </span>
      </p>
      {activityItem.details.old_amount && activityItem.details.new_amount ? (
        <div>
          <p className="text-sm font-medium text-content-300">
            <span className="text-content-1000">Before: </span>
            <span>
              Pet rent (
              {formatToCurrency({
                cents: activityItem.details.old_amount.cents || 0,
                currency: "USD"
              })}
              )
            </span>
          </p>
          <HugeiconsIcon
            icon={ArrowDown02Icon}
            size={20}
            className="text-content-1000 my-2"
          />
          <p className="text-sm font-medium text-content-300">
            <span className="text-content-1000">After: </span>
            <span>
              Pet rent (
              {formatToCurrency({
                cents: activityItem.details.new_amount.cents || 0,
                currency: "USD"
              })}
              )
            </span>
          </p>
        </div>
      ) : null}
      <div className="text-sm font-medium text-content-300 pt-2 border-t border-alpha-40 mt-2">
        Adjusted by {activityItem.author?.name || "--"}
      </div>
    </div>
  );
};
